import Vue, { VueConstructor } from "vue";
import { Service } from "typedi";
import { CoreSymbols } from "@/core/core.symbols";
import AppModal from "~shared/components/AppModal.vue";

@Service({
  global: true,
})
export class ModalsService {
  public open<
    T,
    P extends Record<string, unknown> = Record<string, unknown>,
    C extends VueConstructor = VueConstructor
  >(ModalComponent: C, modalProps?: P): Promise<T> {
    return new Promise((resolve, reject) => {
      const ExtendedComponent = Vue.extend(ModalComponent).extend({
        vuetify: Vue.$container.get(CoreSymbols.vuetify),
      });

      const instance = new ExtendedComponent({
        propsData: modalProps,
        data: {
          modalState: true,
        },
      }) as AppModal;

      instance.close = function close(value) {
        this.modalState = false;
        resolve(value as unknown as T);
      };

      instance.throw = function emitError(error) {
        this.modalState = false;
        reject(error);
      };

      instance.$mount();
      instance.$watch("modalState", (value: boolean) => {
        if (!value) {
          instance.$destroy();
        }
      });
    });
  }
}
